<template lang="pug">
    div
        Select(@on-change="selectExample")
            Option(
                v-for="(rule, index) in examples" 
                :value="index" 
                :label="rule.ruleName"
                :key="index" 
            )
</template>

<script>
export default {
    name: "AlertRulesFormExamples",
    components: {},
    data() {
        let alertMessage =
            "Rule name: {{ruleName}}\nMy query is {{alertRuleQuery}}\nAlert when  {{currentValue}} goes {{alertWhen}} {{alertValue}} {{alertValueUnit}}\nSo now the result of Alerting is {{isAlerting}}";
        return {
            examples: [
                {
                    ruleName: "my_site_goes_viral_check",
                    alertRuleQuery:
                        "server_name: www.mydomain.com AND timestamp: [now-10m TO now]",
                    alertWhen: "above",
                    alertValue: 10000,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "origin_unhealthy_check",
                    alertRuleQuery:
                        "upstream_status: 5* AND timestamp: [now-10m TO now]",
                    alertWhen: "above",
                    alertValue: 5,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "directory_scanner_check",
                    alertRuleQuery:
                        "upstream_status: 404 AND timestamp: [now-10m TO now]",
                    alertWhen: "above",
                    alertValue: 10,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "forbidden_check",
                    alertRuleQuery:
                        "status: 403 AND timestamp: [now-10m TO now]",
                    alertWhen: "above",
                    alertValue: 10,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "spider_is_coming_check",
                    alertRuleQuery:
                        "req_headers.user-agent: (*bot* OR *crawl* OR *spider*) AND timestamp: [now-10m TO now]",
                    alertWhen: "above",
                    alertValue: 20,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "using_to_much_data_check",
                    alertRuleQuery:
                        "servicegroup: myservicegroup AND timestamp: [now-1h TO now]",
                    alertWhen: "above",
                    alertValue: 1,
                    alertValueUnit: "sumGBytes",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "need_acceleration_check",
                    alertRuleQuery:
                        "servicegroup: myservicegroup AND !upstream_cache_status: HIT AND timestamp: [now-1h TO now]",
                    alertWhen: "above",
                    alertValue: 10,
                    alertValueUnit: "sumMBytes",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "slow_request_check",
                    alertRuleQuery:
                        "server_name: *mydomain.com AND request_time: [1 TO *] AND timestamp: [now-10m TO now]",
                    alertWhen: "above",
                    alertValue: 10,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "honey_pot_check",
                    alertRuleQuery:
                        'server_name: www.mydomain.com AND uri: "/admin" AND !cus_realy_addr: 59* AND timestamp: [now-10m TO now]',
                    alertWhen: "above",
                    alertValue: 5,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                },
                {
                    ruleName: "my_site_not_popular_check",
                    alertRuleQuery:
                        "server_name: *mydomain.com AND timestamp: [now-1h TO now]",
                    alertWhen: "below",
                    alertValue: 100,
                    alertValueUnit: "count",
                    alertChannelName: [],
                    alertMessage: alertMessage,
                    isenabled: true
                }
            ]
        };
    },
    props: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        selectExample(index) {
            // console.log(index);
            // console.log(this.examples[index]);
            this.$emit("selectExample", this.examples[index]);
        }
    },
    computed: {},
    beforeDestroy() {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/AlertRules/FormExamples.vue